var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "alert " + _vm.classname }, [
    _c(
      "strong",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.title,
            expression: "title"
          }
        ]
      },
      [_vm._v(_vm._s(_vm.$t(_vm.title)))]
    ),
    _vm._v("\n  " + _vm._s(_vm.$t(_vm.body)) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67bb85f0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67bb85f0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Notification.vue
// module id = 1665
// module chunks = 0